import { render, staticRenderFns } from "./draggable.vue?vue&type=template&id=f9c8405c&scoped=true"
import script from "./draggable.vue?vue&type=script&lang=js"
export * from "./draggable.vue?vue&type=script&lang=js"
import style0 from "./draggable.vue?vue&type=style&index=0&id=f9c8405c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c8405c",
  null
  
)

export default component.exports